<section class="group-register" *appHasPermission="groupPermissions.MODULE">
  <header class="group-register__header">
    <!-- Linha própria, na largura toda, alinhada com a borda do conteúdo (sem o recuo do botão de voltar). -->
    <div class="group-register__crumbs">
      <app-breadcrumb [home]="home" [items]="breadcrumbs()" [favoritable]="false"></app-breadcrumb>
      @if (saveBlockedReason()) {
        <span class="group-register__save-hint" role="status">
          <i class="pi pi-info-circle" aria-hidden="true"></i>{{ saveBlockedReason() }}
        </span>
      }
    </div>
    <!-- Título, Tipo, Nome e ações numa linha (pedido do Victor, 04/11/2026): menos rolagem, mais permissões na tela. -->
    <div class="group-register__top">
      <button
        type="button"
        class="group-register__back"
        aria-label="Voltar para a lista de grupos"
        (click)="cancel()">
        <i class="pi pi-arrow-left"></i>
      </button>
      <!-- Título só para leitor de tela: o breadcrumb já diz onde a pessoa está (pedido do Victor, 04/11/2026). -->
      <h1 class="group-register__title">{{ pageTitle() }}</h1>
      <form class="group-register__form" [formGroup]="form" appAutoFormGroup>
        <div class="group-register__field group-register__field--role">
          <app-select
            label="Tipo de usuário"
            placeholder="Selecione"
            theme="medium"
            [options]="roleOptions()"
            [locked]="isEditing()"
            [lockedTooltip]="roleHint()"
            formControlName="roleId"></app-select>
          <span class="group-register__field-hint">{{ roleHint() }}</span>
        </div>
        <div class="group-register__field group-register__field--name">
          <app-input
            type="text"
            label="Nome do grupo"
            placeholder="Ex.: Controle - Somente leitura"
            theme="medium"
            controlName="name"
            [required]="true"></app-input>
        </div>
      </form>
      <div class="group-register__actions">
        <app-button
          [id]="'cancel-register'"
          label="Cancelar"
          type="button"
          theme="white"
          size="medium"
          [noMargin]="true"
          (sendButtonClick)="cancel()"></app-button>
        <ng-container
          *appHasPermission="isEditing() ? groupPermissions.UPDATE : groupPermissions.CREATE">
          <app-button
            [id]="'register-group'"
            [label]="saveLabel()"
            icon="check"
            type="button"
            size="medium"
            [noMargin]="true"
            [disabled]="!canSave()"
            [isLoading]="saving()"
            loadingText="Salvando..."
            [title]="saveBlockedReason()"
            (sendButtonClick)="save()"></app-button>
        </ng-container>
      </div>
    </div>
  </header>

  @if (state.modules().length) {
    <app-permission-summary
      class="group-register__summary"
      [summary]="state.summary()"
      [changes]="state.changes()"
      [keptUnknown]="state.unknownSelectedCount()"
      [isEditing]="isEditing()"
      (undoAll)="state.undoAll()"
      (undoOne)="state.undoValue($event)"></app-permission-summary>

    @if (state.bulkNotice(); as notice) {
      <!-- Um clique em módulo, área ou "Tudo" pode dar poder de excluir: o aviso diz quanto ligou e desfaz só ele. -->
      <div class="group-register__notice" role="status">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
        <p>
          Ligou <b>{{ notice.added }} permissões</b> em {{ notice.scope }},
          <b>{{ notice.writeAdded }} delas de gravação</b> (criar, editar ou excluir).
        </p>
        <button type="button" class="group-register__link" (click)="state.undoBulk()">
          Desfazer
        </button>
        <button
          type="button"
          class="group-register__notice-close"
          aria-label="Fechar aviso"
          (click)="state.dismissBulkNotice()">
          <i class="pi pi-times"></i>
        </button>
      </div>
    }

    <div class="group-register__workspace">
      <aside class="group-register__tree-card" aria-label="Permissões por tela do menu">
        <div class="group-register__tree-tools">
          <app-search
            size="small"
            placeholder="Buscar permissão ou tela"
            [realTime]="true"
            [clearable]="true"
            [value]="state.query()"
            (sendSearch)="onSearch($event)"></app-search>
          <div class="group-register__tree-filters">
            @if (state.isSearching()) {
              <span class="group-register__tree-results">
                {{ state.searchResultCount() }}
                {{ state.searchResultCount() === 1 ? 'resultado' : 'resultados' }} em
                {{ state.searchResults().length }}
                {{ state.searchResults().length === 1 ? 'tela' : 'telas' }}
              </span>
              <button type="button" class="group-register__link" (click)="onSearch('')">
                Limpar busca
              </button>
            } @else {
              <div class="group-register__show" role="group" aria-label="Mostrar">
                <span>Mostrar:</span>
                <button
                  type="button"
                  [class.is-active]="!state.onlySelected()"
                  [attr.aria-pressed]="!state.onlySelected()"
                  (click)="state.onlySelected.set(false)">
                  Todas
                </button>
                <button
                  type="button"
                  [class.is-active]="state.onlySelected()"
                  [attr.aria-pressed]="state.onlySelected()"
                  (click)="state.onlySelected.set(true)">
                  Só marcadas
                </button>
              </div>
              <button type="button" class="group-register__link" (click)="state.collapseAll()">
                Recolher tudo
              </button>
            }
          </div>
        </div>

        @if (state.visibleTree().length) {
          <app-permission-tree
            [modules]="state.visibleTree()"
            [selected]="state.selected()"
            [initial]="state.initial()"
            [query]="state.isSearching() ? state.query() : ''"
            [activeId]="state.activeNodeId()"
            [expanded]="state.expanded()"
            [expandAll]="state.isSearching()"
            (nodeSelect)="onNodeSelect($event)"
            (nodeToggle)="state.toggleNodeSelection($event)"
            (expandToggle)="state.toggleExpanded($event)"></app-permission-tree>
          @if (modulesWithoutResults().length) {
            <p class="group-register__tree-foot">
              {{ modulesWithoutResults().join(', ') }}: nenhum resultado
            </p>
          }
        } @else {
          <p class="group-register__tree-empty">
            @if (state.isSearching()) {
              Nada encontrado nas telas deste tipo de usuário.
            } @else {
              Nenhuma permissão marcada ainda. Use Mostrar: Todas para ver a árvore inteira.
            }
          </p>
        }
      </aside>

      <div class="group-register__panel-card">
        @if (state.isSearching()) {
          <app-permission-search-results
            [query]="state.query()"
            [results]="state.searchResults()"
            [selected]="state.selected()"
            [initial]="state.initial()"
            (valueChange)="state.setValue($event.value, $event.checked)"
            (bulkChange)="state.setMany($event.values, $event.checked)"
            (screenOpen)="onScreenOpen($event)"
            (clearSearch)="onSearch('')"></app-permission-search-results>
        } @else if (state.activeNode(); as node) {
          <app-permission-screen-panel
            [node]="node"
            [selected]="state.selected()"
            [initial]="state.initial()"
            (valueChange)="state.setValue($event.value, $event.checked)"
            (presetApply)="state.applyPreset($event.node, $event.preset)"
            (screenOpen)="onScreenOpen($event)"></app-permission-screen-panel>
        } @else {
          <div class="group-register__placeholder">
            <i class="pi pi-sitemap"></i>
            <p>Escolha uma tela, área ou módulo na árvore para ver as permissões.</p>
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="group-register__placeholder group-register__placeholder--card">
      @if (catalogLoading()) {
        <app-cog-loading-spinner></app-cog-loading-spinner>
        <p>Carregando as permissões deste tipo de usuário...</p>
      } @else if (catalogError()) {
        <i class="pi pi-exclamation-circle"></i>
        <p>As permissões deste tipo de usuário não carregaram.</p>
        <app-button
          [id]="'reload-catalog'"
          label="Tentar de novo"
          theme="white"
          size="small"
          [noMargin]="true"
          (sendButtonClick)="reloadCatalog()"></app-button>
      } @else if (catalogLoaded()) {
        <i class="pi pi-info-circle"></i>
        <p>Este tipo de usuário não tem permissões para escolher. Escolha outro tipo.</p>
      } @else if (isEditing()) {
        <app-cog-loading-spinner></app-cog-loading-spinner>
        <p>Abrindo o grupo...</p>
      } @else {
        <i class="pi pi-users"></i>
        <p>Escolha o <b>Tipo de usuário</b> para ver as permissões que ele pode receber.</p>
      }
    </div>
  }
</section>
